import "../../styles/ModalPopupType4.scss"

export default function SearchResultsModalContent({ text, content }) {
    return (
          <div className= 'd-flex justify-content-center'>
          <div>
            <div className="result-text px-lg-1 px-md-2 px-0 pt-2">{text}</div>
           {content!== "" && <div className="result-subtext mx-3 px-lg-1 px-md-2 px-0 pt-2">{content}</div>} 
          </div>
        </div>
    );
  }